import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminClaimRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/invoices/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/admin/Claims/AdminClaimPage/AdminClaimPage').then((d) => d.Route));
